import { APIEvent } from '../events/apiEvent'
import { EventBus } from '../event-bus'
import { StatusBarEvent } from '../events/statusBarEvent'
import { B64ToUTF8, UTF8ToB64, JSONToCSVConvertor, createReportLabel } from '../utils'
import { EMAIL_CODES } from '../constants/userComms/emailCodes'
import { SMS_CODES } from '../constants/userComms/smsCodes'

export default {
  data: function () {
    return {
      selectedTenant: null,
      selectedCode: null,
      selectedType: null,
      selectedLanguage: null,
      selectedEmail: {},
      updatedSubject: '',
      updatedBody: '',
      updatedTokens: '',
      hasUpdates: false,
      currentPage: 1,
      perPage: 10,
      hasNextPage: false,
      paginatedList: [],
      filters: [
        {
          value: 'selectedTenant',
          api: 'tenant_id'
        },
        {
          value: 'selectedCode',
          api: 'email_code'
        },
        {
          value: 'selectedType',
          api: 'comm_type'
        },
        {
          value: 'selectedLanguage',
          api: 'language'
        }
      ],
      emailCodes: [],
      commType: [],
      languages: [],
      fields: {
        emailCode: {
          label: 'Email Code',
          tdClass: 'width-100'
        },
        commType: {
          label: 'Type',
          tdClass: 'width-100'
        },
        languageDesc: {
          label: 'Language',
          tdClass: 'width-100'
        },
        tenantName: {
          label: 'Tenant',
          tdClass: 'width-250'
        },
        subject: {
          label: 'Subject',
          formatter: this.decode
        }
      }
    }
  },
  computed: {
    tenants () {
      return this.$store.state.tenantsList
    },
    messageList () {
      return this.$store.state.messageList
    }
  },
  watch: {
    updatedSubject: function (newSubject, oldSubject) {
      this.hasUpdates = newSubject !== oldSubject && oldSubject !== ''
    },
    updatedBody: function (newBody, oldBody) {
      this.hasUpdates = newBody !== oldBody && oldBody !== ''
    },
    updatedTokens: function (newTokens, oldTokens) {
      this.hasUpdates = newTokens !== oldTokens && oldTokens !== ''
    }
  },
  methods: {
    decode: function (value) {
      if (value === 'null') {
        return '-'
      } else {
        return B64ToUTF8(value)
      }
    },
    applyFilters: function () {
      this.currentPage = 1
      let options = {}
      for (var i = 0; i < this.filters.length; i++) {
        let filter = this.filters[i]
        if (this[filter.value] !== null && typeof this[filter.value] !== 'undefined') {
          options[filter.api] = this[filter.value]
        }
      }
      this.fetchMessageList(options)
    },
    showEmail: function (data) {
      let options = {email_id: data.item.id}
      this.$store.dispatch(APIEvent.FETCH_MESSAGE, options)
        .then((res) => {
          this.selectedEmail = res.data
          // the following two params are set to pass validation
          // they are not exposed for editing
          this.selectedLanguage = res.data.languageCode
          this.selectedTenant = this.getTenantId(res.data.tenantName)
          // end
          this.updatedSubject = B64ToUTF8(this.selectedEmail.subject) || ''
          this.updatedBody = B64ToUTF8(this.selectedEmail.body) || ''
          if (this.updatedBody.indexOf('{{new_line}}') > -1) {
            this.updatedBody = this.updatedBody.replace('{{new_line}}', '\n')
          }
          this.updatedTokens = this.selectedEmail.tokens === 'null'
            ? '-'
            : this.selectedEmail.tokens
          this.$refs.emailView.show()
        })
        .catch(this.handleError)
    },
    closeDialog: function (event) {
      this.selectedTenant = null
      this.selectedType = null
      this.selectedLanguage = null
      this.selectedCode = null
      if (event.type === 'hidden') {
        this.$refs.emailView.hide()
      }
    },
    addNew: function () {
      this.selectedTenant = this.tenants[0].id
      this.selectedType = 'Email'
      this.selectedLanguage = 'en'
      // use index 10 as it is first E code for email
      this.selectedCode = this.emailCodes[10].value
      this.updatedBody = ''
      this.updatedSubject = ''
      this.updatedTokens = ''
      this.$refs.addNewView.show()
    },
    save: function (event) {
      let isNew = event.target.id !== 'email-view'
      let validation = this.formIsValid(isNew)
      if (!validation.valid) {
        EventBus.$emit(StatusBarEvent.WARNING, validation.message)
        event.preventDefault()
        return
      }
      let options = {}
      options.subject = UTF8ToB64(this.updatedSubject)
      if (this.selectedType === 'SMS' || this.selectedEmail.commType === 'SMS') {
        if (this.updatedBody.indexOf('\n') > -1) {
          this.updatedBody = this.updatedBody.replace('\n', '{{new_line}}')
        }
      }
      options.body = UTF8ToB64(this.updatedBody)
      if (isNew) {
        options.tenant_id = this.selectedTenant
        options.email_code = this.selectedCode
        options.language_id = this.getLanguageId(this.selectedLanguage)
        options.comm_type_id = this.getTypeId(this.selectedType)
        options.email_tokens = this.updatedTokens
        this.$store.dispatch(APIEvent.ADD_MESSAGE, options)
          .then(() => {
            EventBus.$emit(StatusBarEvent.SUCCESS, 'Message added successfully')
            this.applyFilters()
          })
          .catch(this.handleError)
      } else {
        options.email_id = this.selectedEmail.id
        options.email_tokens = this.updatedTokens === '-' ? '' : this.updatedTokens
        this.$store.dispatch(APIEvent.UPDATE_MESSAGE, options)
          .then(() => {
            EventBus.$emit(StatusBarEvent.SUCCESS, 'Message updated successfully')
            this.hasUpdates = false
            this.applyFilters()
          })
          .catch(this.handleError)
      }
    },
    preview: function () {
      let prevWindow = window.open('preview')
      let content = '<html><head><meta http-equiv="Content-Type" content="text/html;'
      content += ' charset=UTF-8"><title>Msg Preview</title></head><body>'
      content += this.updatedBody
      content += '</body></html>'
      prevWindow.document.write(content)
      prevWindow.document.close()
    },
    downloadExport: function () {
      let data = JSON.stringify(this.$store.state.messageList)
      let title = createReportLabel('Message List')
      let headings = {
        id: 'ID',
        emailCode: 'emailCode',
        tenantName: 'tenantName',
        commType: 'commType',
        languageCode: 'languageDesc'
      }
      JSONToCSVConvertor(data, title, true, headings)
    },
    fetchMessageList: function (options) {
      this.$store.dispatch(APIEvent.FETCH_MESSAGE_LIST, options || {})
        .then(() => {
          this.paginateResults()
        })
        .catch(this.handleError)
    },
    paginateResults: function () {
      // create an index to start slice of master data
      let startPos = (this.currentPage - 1) * this.perPage
      // create count of records to copy
      let endPos = (this.currentPage * this.perPage)
      // use slice to make shallow copy of master data for use as 'page'
      this.paginatedList = this.$store.state.messageList.slice(startPos, endPos)
      // if there are more records than allowed in
      // current page, set hasNextPage to true
      this.hasNextPage = this.$store.state.messageList.length > (this.currentPage * this.perPage)
    },
    page: function (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        // increment page number
        this.currentPage++
        // determine if there are more records
        this.hasNextPage = this.$store.state.messageList.length > (this.currentPage * this.perPage)
      } else {
        this.currentPage--
        // if we reach here, there is always a next page
        this.hasNextPage = true
      }
      this.paginateResults()
    },
    populateEmailDropdown: function () {
      let emailCodes = this.emailCodes
      emailCodes.push({text: 'All', value: null})
      for (let prop in EMAIL_CODES) {
        let eCode = {text: EMAIL_CODES[prop], value: EMAIL_CODES[prop]}
        emailCodes.push(eCode)
      }
      for (let prop in SMS_CODES) {
        let sCode = {text: SMS_CODES[prop], value: SMS_CODES[prop]}
        emailCodes.push(sCode)
      }
      emailCodes.sort(function (a, b) {
        return a.text === b.text ? 0 : a.text < b.text ? -1 : 1
      })
    },
    populateLanguageDropdown: function () {
      let langs = this.$store.state.languageList
      this.languages.push({text: 'All', value: null})
      for (let i = 0; i < langs.length; i++) {
        let lang = langs[i]
        let option = {}
        option.text = lang.description
        option.value = lang.code
        this.languages.push(option)
      }
      this.selectedLanguage = null
    },
    populateTypeDropdown: function () {
      let types = this.$store.state.messageTypes
      this.commType.push({text: 'All', value: null})
      for (let i = 0; i < types.length; i++) {
        let type = types[i]
        let option = {}
        option.text = type.code
        option.value = type.code
        this.commType.push(option)
      }
    },
    getLanguageId: function (langCode) {
      let list = this.$store.state.languageList
      for (let i = 0; i < list.length; i++) {
        let lang = list[i]
        if (lang.code === langCode) {
          return lang.id
        }
      }
    },
    getTypeId: function (typeCode) {
      let list = this.$store.state.messageTypes
      for (let i = 0; i < list.length; i++) {
        let type = list[i]
        if (type.code === typeCode) {
          return type.id
        }
      }
    },
    getTenantId: function (tenantName) {
      for (var i = 0; i < this.tenants.length; i++) {
        if (this.tenants[i].name === tenantName) {
          return this.tenants[i].id
        }
      }
    },
    formIsValid: function (isNew) {
      let valid = true
      let message = ''
      let nullValidators = [
        {name: 'body', variable: this.updatedBody},
        {name: 'subject', variable: this.updatedSubject},
        {name: 'token', variable: this.updatedTokens}
      ]
      // add extra validators for new emails
      if (isNew) {
        nullValidators.push(
          {
            name: 'tenant',
            variable: this.selectedTenant
          }, {
            name: 'language',
            variable: this.selectedLanguage
          }
        )
      }
      for (let i = 0; i < nullValidators.length; i++) {
        let prop = nullValidators[i].variable
        prop = typeof prop === 'string' ? prop.trim() : prop
        if (prop === null || prop === '') {
          valid = false
          message = 'Please enter a ' + nullValidators[i].name
        }
      }
      if (this.selectedType === 'Email' && this.selectedCode.indexOf('E') === -1) {
        valid = false
        message = 'Email message type must have E code'
      }
      if (this.selectedType === 'SMS' && this.selectedCode.indexOf('C') === -1) {
        valid = false
        message = 'SMS message type must have C code'
      }
      return {valid, message}
    },
    handleError: function (error) {
      let message = 'This action could not be performed. Please check and try again :: '
      EventBus.$emit(StatusBarEvent.ERROR, message + error.message)
    }
  },
  mounted: function () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      if (this.$store.state.messageList === null) {
        this.fetchMessageList()
      } else {
        this.paginateResults()
      }
      if (this.$store.state.languageList.length < 1) {
        this.$store.dispatch(APIEvent.FETCH_LANGUAGE_LIST)
          .then(() => {
            this.populateLanguageDropdown()
          })
      } else {
        this.populateLanguageDropdown()
      }
      if (this.$store.state.messageTypes.length < 1) {
        this.$store.dispatch(APIEvent.FETCH_MESSAGE_TYPES)
          .then(() => {
            this.populateTypeDropdown()
          })
      } else {
        this.populateTypeDropdown()
      }
      if (this.emailCodes.length < 1) {
        this.populateEmailDropdown()
      }
    }
  }
}
